module.exports = __webpack_public_path__ + "static/media/21ECLAC42.2b68ff10.jpg";